<template>
  <sea-page
    title="Home"
    :showCompanyHeader="activeProfile.role === 'ROLE_CONSULTANT'"
    :selectCompany="activeProfile.role === 'ROLE_CONSULTANT'"
    :back="activeProfile.role === 'ROLE_CONSULTANT'"
    backPage="/consultant/home"
  >
    <v-navigation-drawer
      v-model="drawer"
      :expand-on-hover="mini"
      absolute
      permanent
      right
      v-if="drawer_active"
    >
      <v-list-item>
        <v-list-item-icon>
          <v-icon :color="colors.primarycolor">mdi-widgets</v-icon>
        </v-list-item-icon>
        <v-list-item-title :color="colors.primarycolor" class="text-formatter">
          pannello <span v-if="mini == false">bloccato</span
          ><span v-else>sbloccato</span>
        </v-list-item-title>
        <v-btn v-model="mini" icon @click.stop="save">
          <v-icon :color="colors.primarycolor" >{{
            this.mini ? "mdi-chevron-double-left" : "mdi-chevron-double-right"
          }}</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-group
          v-for="{ name, color, icon, i, checkIcon } in lines"
          :key="i"
          no-action
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-icon>
                <v-icon :color="color">{{ icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-formatter">
                {{ name }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-btn
                  small
                  color="#1976D2"
                  icon
                  @click="
                    !checkValue(name) ? selectAll(name) : deselectAll(name);
                    aggiornaCheckIcon(name);
                  "
                  ><v-icon >{{ checkIcon }}</v-icon></v-btn
                >
              </v-list-item-action>
              <v-list-item-title
                class="font-weight-bold"
                :color="colors.primarycolor"
              >
                TUTTI
              </v-list-item-title>
              <v-list-item-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item v-for="x in dati[name]" :key="x.i">
              <v-list-item-action>
                <v-checkbox
                  @change="
                    aggiornaCheckIcon(name);
                    aggiornaLayout(layout);
                  "
                  v-model="x.visible"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-title class="text-little">
                {{ x.name }}
              </v-list-item-title>
              <v-list-item-icon></v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="colors.primarycolor" >mdi-refresh</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <v-btn :color="colors.primarycolor" block text @click="resetWidget">
              <b>reset widgets</b>
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-navigation-drawer>
    <div :style="{ marginRight: sbw }" ref="gridContainer">
      <grid-layout
        :layout="layout"
        :col-num="12"
        :row-height="50"
        is-draggable
        is-resizable
        vertical-compact
        use-css-transforms
        responsive
        :responsive-layouts="responsiveLayouts"
        :breakpoints="gridBreakpoints"
        :cols="gridcols"
        @layout-updated="aggiornaLayout"
        @breakpoint-changed="breakpointChanged"
      >
        <grid-item
          v-for="y in visibleLayout"
          :static="y.static"
          :x="y.x"
          :y="y.y"
          :w="y.w"
          :h="y.h"
          :minH="y.minH"
          :i="y.i"
          :key="y.i"
          drag-allow-from=".vue-draggable-handle"
        >
          <component
            @closed="
              removeItem(y.i);
              aggiornaCheckIcon();
            "
            :is="y.widget"
          ></component>
        </grid-item>
      </grid-layout>
    </div>
  </sea-page>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import CompanyDetail from "@/components/Widgets/CompanyDetail.vue";
import Note from "@/components/Widgets/Note.vue";
import Doclavrecazi from "@/components/Widgets/Doclavrecazi.vue";
import DatiLavoratori from "@/components/Widgets/DatiLavoratori.vue";
import Ratei from "@/components/Widgets/Ratei.vue";
import PresenzeAssenzeLavoratori from "@/components/Widgets/PresenzeAssenzeLavoratori.vue";
import PresenzeAssenze from "@/components/Widgets/PresenzeAssenze.vue";
import RetribuzioneTrattenute from "@/components/Widgets/RetribuzioneTrattenute.vue";
import ForzaAziendale from "@/components/Widgets/ForzaAziendale.vue";
import FilialiCantieri from "@/components/Widgets/FilialiCantieri.vue";
// import SituazioneEconomicaPatrimoniale from "@/components/Widgets/SituazioneEconomicaPatrimoniale.vue";
import SalariCostiPersonale from "@/components/Widgets/SalariCostiPersonale.vue";
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";
import { responsiveLayouts } from "@/grid_layout";

const gridBreakpoints = { xl: 1483, lg: 1116, md: 776, sm: 600, xs: 0 };
const gridcols = { xl: 12, lg: 9, md: 6, sm: 3, xs: 3 };

const generico = "#1565C0";
const icon_generico = "mdi-note-multiple";
const lavoro = "#DA550F";
const icon_lavoro = "mdi-account-group";
export const contabile = "#98204A";
export const icon_contabile = "mdi-poll";
/*export const bilancio = "#1B5E20";
export const icon_bilancio = "mdi-text-box-multiple-outline";
export const dichiarativi = "#006064";
export const icon_dichiarativi = "mdi-text-box-outline";
export const aziendale = "#B71C1C";
export const icon_aziendale = "mdi-domain";*/

const lines = [
  {
    i: "1",
    name: "Generico",
    icon: icon_generico,
    color: generico,
    checkIcon: "",
  },
  { i: "2", name: "Lavoro", icon: icon_lavoro, color: lavoro, checkIcon: "" },
  // {
  //   i: "3",
  //   name: "Contabilità",
  //   icon: icon_contabile,
  //   color: contabile,
  //   checkIcon: "",
  // },
  /* {i: "4", name: "Bilancio", icon: icon_bilancio, color: bilancio, checkIcon: ""},
  {i: "5", name: "Dichiarativi", icon: icon_dichiarativi, color: dichiarativi, checkIcon: ""},
  {i: "6", name: "Aziendale", icon: icon_aziendale, color: aziendale, checkIcon: ""},*/
];

export default {
  name: "Home",
  mixins: [mixin],
  components: {
    GridLayout,
    GridItem,
    CompanyDetail,
    Note,
    Doclavrecazi,
    DatiLavoratori,
    Ratei,
    PresenzeAssenzeLavoratori,
    PresenzeAssenze,
    ForzaAziendale,
    RetribuzioneTrattenute,
    FilialiCantieri,
    // SituazioneEconomicaPatrimoniale,
    SalariCostiPersonale,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.codiceAzienda) {
        vm.setCurrentCompany(to.query.codiceAzienda);
      }
    });
  },
  mounted() {
    this.layout = JSON.parse(
      localStorage.layout
        ? localStorage.getItem("layout")
        : this.defaultLayout()
    );
    if (localStorage.mini) this.mini = JSON.parse(localStorage.getItem("mini"));
    this.setLayout();
  },
  data() {
    return {
      dati: {},
      responsiveLayouts,
      gridBreakpoints,
      gridcols,
      lines,
      layout: [],
      drawer: false,
      mini: true,
      drawer_active: true,
    };
  },
  methods: {
    ...mapActions({
      setCurrentCompany: "widget/setCurrentCompany",
    }),
    setLayout(category) {
      this.lines.forEach(({ name }) => {
        this.dati = { ...this.dati, [name]: this.filteredLayout(name) };
      });
      this.aggiornaCheckIcon(category);
    },
    //*1. per categoria 2. tutti
    aggiornaCheckIcon(category) {
      category
        ? Object.entries(this.lines).forEach(([, value]) => {
            value.name == category
              ? (value.checkIcon = this.checkIcon(category))
              : "";
          })
        : Object.entries(this.lines).forEach(([, value]) => {
            value.checkIcon = this.checkIcon(value.name);
          });
    },
    checkValue(category) {
      return this.dati[category].every((element) => element.visible);
    },
    checkIcon(category) {
      return this.dati[category].every((element) => element.visible)
        ? "mdi-checkbox-marked"
        : this.dati[category].some((element) => element.visible)
        ? "mdi-minus-box"
        : "mdi-checkbox-blank-outline";
    },
    selectAll(category) {
      this.dati[category].forEach((element) => {
        element.visible = true;
      });
      this.aggiornaLayout(this.layout);
    },
    deselectAll(category) {
      this.dati[category].forEach((element) => {
        element.visible = false;
      });
      this.aggiornaLayout(this.layout);
    },
    aggiornaLayout(newLayout) {
      localStorage.setItem("layout", JSON.stringify(newLayout));
    },
    breakpointChanged(_, newLayout) {
      this.aggiornaLayout(newLayout);
    },
    resetWidget() {
      localStorage.removeItem("layout");
      this.layout = JSON.parse(this.defaultLayout());
      this.setLayout();
    },
    filteredLayout(category) {
      return this.layout.filter((item) => {
        return item.category === category;
      });
    },
    save() {
      this.mini = !this.mini;
      localStorage.mini = this.mini;
    },
    removeItem(i) {
      const index = this.layout.findIndex((item) => item.i === i);
      this.layout[index].visible = false;
      this.aggiornaLayout(this.layout);
    },
    defaultLayout() {
      const w = this.$refs.gridContainer.clientWidth;
      const breakpoint =
        w <= this.gridBreakpoints.sm
          ? "xs"
          : w <= this.gridBreakpoints.md
          ? "sm"
          : w <= this.gridBreakpoints.lg
          ? "md"
          : w <= this.gridBreakpoints.xl
          ? "lg"
          : "xl";
      return JSON.stringify(this.responsiveLayouts[breakpoint]);
    },
  },
  watch: {
    "$route.query.codiceAzienda"() {
      this.$router.go();
    },
  },
  computed: {
    ...mapGetters({
      activeProfile: "account/activeProfile",
    }),
    sbw() {
      return this.drawer_active ? (this.mini ? "75px" : "265px") : 0;
    },
    visibleLayout() {
      return this.layout.filter((item) => {
        return item.visible === true;
      });
    },
  },
};
</script>

<style>

.text-little {
  font-size: 0.6rem !important;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.0333333333em !important;
  font-family: "Roboto", sans-serif !important;
}
.v-list {
  padding: 0px;
}
</style>